module.exports = __webpack_public_path__ + "img/list_Character_sq_01.3b99b9ba.jpeg";